export default "__VITE_ASSET__20f76981__"